"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockFishingReportWithWaterbodyDetail = exports.mockFishingReport = exports.mockVideo = void 0;
const forage_1 = require("./forage");
const list_1 = require("./list");
const product_1 = require("./product");
const season_1 = require("./season");
const species_1 = require("./species");
const structure_1 = require("./structure");
const technique_1 = require("./technique");
const user_1 = require("./user");
const waterbody_1 = require("./waterbody");
function mockVideo(overrides = {}) {
    return {
        id: 1,
        src: 'http://example.com/move.mp4',
        image: 'http://example.com/thumbnail.jpg',
        ...overrides,
    };
}
exports.mockVideo = mockVideo;
function mockFishingReport(overrides = {}) {
    return {
        accepted: true,
        comments: 'mock comments',
        converted: false,
        created_at: '2019-11-25T17:30:52.961Z',
        featured_product: (0, product_1.mockProduct)(),
        forage: (0, forage_1.mockForage)(),
        id: 1,
        image: 'http://example.com/jpg.jpg',
        list: (0, list_1.mockList)(),
        locked: false,
        outing_date: '2022-07-04',
        season: (0, season_1.mockSeason)(),
        slug: 'mock_slug',
        species: (0, species_1.mockSpecies)(),
        structure: (0, structure_1.mockStructure)(),
        style: (0, technique_1.mockTechnique)(),
        technique: (0, technique_1.mockTechnique)(),
        water_temperature: 65,
        user: (0, user_1.mockUserPublic)(),
        video: mockVideo(),
        views: 0,
        waterbody: (0, waterbody_1.mockWaterbody)(),
        ...overrides,
    };
}
exports.mockFishingReport = mockFishingReport;
function mockFishingReportWithWaterbodyDetail(overrides = {}) {
    return {
        ...mockFishingReport(overrides),
        waterbody: (0, waterbody_1.mockWaterbodyDetail)(),
        ...overrides,
    };
}
exports.mockFishingReportWithWaterbodyDetail = mockFishingReportWithWaterbodyDetail;
